<span class="cm-label" [title]="$label()">{{ $label() }}</span>
<cm-toggle [toggle]="$value() ?? false" [disabled]="!$editingEnabled()" (toggleChange)="valueChange.emit($event)"></cm-toggle>
